import { render } from "./org-support-cases-table.vue?vue&type=template&id=45e634e8&scoped=true"
import script from "./org-support-cases-table.vue?vue&type=script&lang=js"
export * from "./org-support-cases-table.vue?vue&type=script&lang=js"

import "./org-support-cases-table.vue?vue&type=style&index=0&id=45e634e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e634e8"]])

export default __exports__